import { MtaGlobalConfig } from '@tencent/wphk-bi';

const mtaGlobalConfig: MtaGlobalConfig = {
  sid: '500008935',
  cid: '500009774',

  auth: {
    groupId: 10078,
    appKey: 'rta_access',
    appSecret: '',
  },

  scanInfo: {
    route: 'src/router.ts',
    logic: '',
    tempIdForA: 109,
    tempIdForBC: 230,
    developer: 'shutinliang',
    productor: 'sidouzhang',
    // @ts-expect-error
    subgroupRuleId: 64, // 扩展字段必须符合的约束规则（提前在海雀中定义，海雀平台查询ID http://fit.oa.com/hq/manage/rule）
  },

  group: 'prom',
  groupDesc: '运营',
  project: 'coupon-campaign',
  projectDesc: '领券活动主会场',
};

export default mtaGlobalConfig;
